// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { useRef, useState } from 'react';
import { ContextualMenu, IContextualMenuProps } from '@fluentui/react';
import { Tooltip } from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import * as styles from '../styles/AssessmentHeader.styles';

export interface AssessmentHeaderProps {
  userName?: string;
  userRole?: string;
  onLogout?: () => void;
  /** Optional URL for Read Me document; when set, button opens this link. */
  readmeHref?: string;
  /** Optional custom handler for Read Me button (overrides readmeHref if both set). */
  onReadMeClick?: () => void;
}

export const AssessmentHeader = ({
  userName = 'Alex Thompson',
  userRole = 'Lead AI Architect',
  onLogout,
  readmeHref,
  onReadMeClick
}: AssessmentHeaderProps): JSX.Element => {
  const [showMenu, setShowMenu] = useState(false);
  const [readMeHover, setReadMeHover] = useState(false);
  const avatarRef = useRef<HTMLDivElement>(null);

  const initial = userName ? userName.charAt(0).toUpperCase() : 'A';

  const handleReadMeClick = (): void => {
    if (onReadMeClick) {
      onReadMeClick();
      return;
    }
    if (readmeHref) {
      window.open(readmeHref, '_blank', 'noopener,noreferrer');
      return;
    }
  };

  const readMeButtonStyle = {
    ...styles.readmeButton,
    ...(readMeHover ? styles.readmeButtonHover : {})
  };

  const menuProps: IContextualMenuProps = {
    items: [
      {
        key: 'logout',
        text: 'Log out',
        iconProps: { iconName: 'SignOut' },
        onClick: () => {
          setShowMenu(false);
          onLogout?.();
        }
      }
    ],
    onDismiss: () => setShowMenu(false),
    directionalHint: 6
  };

  return (
    <header style={styles.headerRoot}>
      {/* <div style={styles.headerLeft}>
        <span style={styles.statusDot} />
        <h1 style={styles.titleText}>Assessment Agent</h1>
      </div> */}

      <div style={styles.headerRight}>
        {/* <Tooltip title='Click to open "Read Me" document' arrow>
          <button
            type="button"
            style={readMeButtonStyle}
            onClick={handleReadMeClick}
            onMouseEnter={() => setReadMeHover(true)}
            onMouseLeave={() => setReadMeHover(false)}
            aria-label="Open Read Me document"
          >
            <DescriptionIcon sx={{ fontSize: 20, color: 'inherit' }} />
            <span style={styles.readmeButtonLabel}>Read Me</span>
          </button>
        </Tooltip> */}
        {/* <div style={styles.userInfo}>
          <span style={styles.userName}>{userName}</span>
          <span style={styles.userRole}>• {userRole.toUpperCase()}</span> 
        </div> */}
        {/* <div
          ref={avatarRef}
          style={styles.headerAvatar}
          onClick={() => setShowMenu(!showMenu)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setShowMenu(!showMenu)}
        >
          {initial}
        </div> */}
        {/* {showMenu && avatarRef.current && <ContextualMenu {...menuProps} target={avatarRef.current} />} */}
      </div>
    </header>
  );
};
